import React from 'react';
import PropTypes from 'prop-types';
import PaymentMethodModel from 'models/payment-method';
import MailCheck from 'react-mailcheck';

const propTypes = {
  placeholder: PropTypes.string,
  existingPaymentMethod: PropTypes.instanceOf(PaymentMethodModel),
};

const defaultProps = {
  placeholder: null,
  existingPaymentMethod: null,
};

class EmailInput extends React.Component {
  constructor(props) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.useSuggestion = this.useSuggestion.bind(this);
    this.onChange = this.onChange.bind(this);

    this.state = { email: '' };
  }

  componentWillMount() {
    const { existingPaymentMethod } = this.props;

    if (!existingPaymentMethod || !existingPaymentMethod.get('businessProfile')) { return; }

    let newEmail = existingPaymentMethod.get('businessProfile').first().get('email');
    newEmail = newEmail && newEmail.toString();

    this.setState({ email: newEmail });
  }

  componentWillReceiveProps(nextProps) {
    const { existingPaymentMethod } = nextProps;

    if (!existingPaymentMethod || !existingPaymentMethod.get('businessProfile')) { return; }

    let newEmail = existingPaymentMethod.get('businessProfile').first().get('email');
    newEmail = newEmail && newEmail.toString();

    if (!(this.props.existingPaymentMethod && this.props.existingPaymentMethod.get('businessProfile'))) {
      this.setState({ email: newEmail });
    }
  }

  onBlur() {
    this.setState({ email: this.emailField.value });
  }

  onChange(e) {
    this.setState({ email: e.target.value });
  }

  useSuggestion() {
    const suggestion = this.mailcheck.state.suggestion.full;
    this.emailField.value = suggestion;
    this.setState({ email: suggestion });
  }

  renderEmailSuggestion() {
    return (
      <MailCheck ref={(mailcheck) => { this.mailcheck = mailcheck; }} email={this.state.email}>
        {(suggestion) => {
          if (suggestion) {
            return (
              <div className="email-suggestion">
                Did you mean {<span className="suggestion-value" onClick={this.useSuggestion}>{suggestion.full}</span>}?
              </div>
            );
          }
          return null;
        }
        }
      </MailCheck>
    );
  }

  render() {
    return (
      <div className="col-xs-12 col-md-7 form-group">
        <label htmlFor="profile-email">
          BUSINESS EMAIL
        </label>
        <input
          ref={(input) => { this.emailField = input; }}
          id="profile-email"
          data-field-name="profile-email"
          className="braintree-field form-control"
          onBlur={this.onBlur}
          onChange={this.onChange}
          onFocus={this.onFocus}
          type="email"
          value={this.state.email}
          placeholder={this.props.placeholder}
        />
        { this.state.email ? this.renderEmailSuggestion() : null }
      </div>
    );
  }
}

EmailInput.propTypes = propTypes;
EmailInput.defaultProps = defaultProps;

export default EmailInput;
